"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var _ = tslib_1.__importStar(require("@antv/util"));
var event_1 = require("../../util/event");
exports.EVENT_MAP = event_1.EVENT_MAP;
exports.onEvent = event_1.onEvent;
var SHAPE_EVENT_MAP = {
    onAreaClick: 'area:click',
    onAreaDblclick: 'area:dblclick',
    onAreaMousemove: 'area:mousemove',
    onAreaMouseenter: 'area:mouseenter',
    onAreaMouseleave: 'area:mouseleave',
    onAreaMousedown: 'area:mousedown',
    onAreaMouseup: 'area:mouseup',
    onAreaContextmenu: 'area:contextmenu',
    onLineClick: 'line:click',
    onLineDblclick: 'line:dblclick',
    onLineMousemove: 'line:mousemove',
    onLineMouseenter: 'line:mouseenter',
    onLineMouseleave: 'line:mouseleave',
    onLineMousedown: 'line:mousedown',
    onLineMouseup: 'line:mouseup',
    onLineContextmenu: 'line:contextmenu',
    onPointClick: 'point:click',
    onPointDblclick: 'point:dblclick',
    onPointMousemove: 'point:mousemove',
    onPointMouseenter: 'point:mouseenter',
    onPointMouseleave: 'point:mouseleave',
    onPointMousedown: 'point:mousedown',
    onPointMouseup: 'point:mouseup',
    onPointContextmenu: 'point:contextmenu',
};
_.assign(event_1.EVENT_MAP, SHAPE_EVENT_MAP);
//# sourceMappingURL=event.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/g2plot/lib/plots/area/event.js
// module id = 873
// module chunks = 37